import { inputCls } from './styles';
import { OWNER_STAFF_ID, staffName } from '../../core/rules/salonDays';
import type { OpeningDay, StaffProfile } from '../../core/types/site';
type Props = {
  value: OpeningDay[];
  onChange: (value: OpeningDay[]) => void;
  /** Met meer dan één (actieve) medewerker: per open dag kiezen wie er werkt. */
  staff?: StaffProfile[];
};

/** Standaardtijden als je een dag op "open" zet. */
const DEFAULT_OPEN = '09:00';
const DEFAULT_CLOSE = '17:00';

/** Per dag open of dicht, met tijden. */
export function OpeningHoursEditor({
  value,
  onChange,
  staff = []
}: Props) {
  const set = (i: number, patch: Partial<OpeningDay>) => onChange(value.map((d, j) => j === i ? {
    ...d,
    ...patch
  } : d));
  const active = staff.filter(s => s.active);
  const pickWho = active.length > 1;
  return <ul className="divide-y divide-line" data-id="element-5307" data-mp="2folf9jarfb5s">
      {value.map((d, i) => {
      const open = Boolean(d.open && d.close);
      const wrong = Boolean(d.open && d.close && d.open >= d.close);
      const errorId = `hours-${d.weekday}-error`;
      // Telefoon: dag + "open" op één regel, de tijden eronder over de volle breedte.
      // Vanaf sm alles op één regel. Native tijdvelden: het toestel toont zijn eigen tijdkiezer.
      return <li key={d.weekday} className="grid gap-x-4 gap-y-2 py-3 sm:grid-cols-[6rem_auto_1fr] sm:items-center" data-id="element-5308" data-mp="1dpbwzj2ld1gu" data-mpi={i}>
            <div className="flex items-center justify-between gap-4 sm:contents" data-id="element-5309" data-mp="1ht9szkwmdw5o">
              <span className="text-[15px] text-ink sm:text-[14px]" data-id="element-5310" data-mp="13yh8e81vhps8">{d.day}</span>
              <label className="flex min-h-11 items-center gap-2.5 text-[14px] text-muted sm:min-h-0 sm:text-[13px]" data-id="element-5311" data-mp="18radix19704u">
                <input type="checkbox" checked={open} onChange={e => set(i, e.target.checked ? {
              open: DEFAULT_OPEN,
              close: DEFAULT_CLOSE
            } : {
              open: undefined,
              close: undefined
            })} className="h-5 w-5 accent-clay sm:h-4 sm:w-4" data-id="element-5312" data-mp="u3fk1eff8rqp" />
                Open<span className="sr-only" data-id="element-5313" data-mp="2rp6mqesq3kwm"> op {d.day}</span>
              </label>
            </div>
            {open ? <span className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-2 sm:flex sm:flex-wrap" data-id="element-5314" data-mp="2mxybrebqvrhc">
                <input type="time" value={d.open} onChange={e => set(i, {
            open: e.target.value
          })} className={`${inputCls} min-w-0 sm:w-32`} aria-label={`${d.day} open vanaf`} aria-invalid={wrong} aria-describedby={wrong ? errorId : undefined} data-id="element-5315" data-mp="2i0ewqc783aoc" />
                <span className="text-muted" aria-hidden="true" data-id="element-5316" data-mp="31mbc0nhv7whn">
                  –
                </span>
                <input type="time" value={d.close} onChange={e => set(i, {
            close: e.target.value
          })} className={`${inputCls} min-w-0 sm:w-32`} aria-label={`${d.day} open tot`} aria-invalid={wrong} aria-describedby={wrong ? errorId : undefined} data-id="element-5317" data-mp="2wn88x8lg40cb" />
                {pickWho && <select value={d.staffId || OWNER_STAFF_ID} onChange={e => set(i, {
            staffId: e.target.value === OWNER_STAFF_ID ? undefined : e.target.value
          })} className={`${inputCls} col-span-3 min-w-0 sm:w-36`} aria-label={`Wie werkt er op ${d.day}`} data-id="element-5318" data-mp="5qeuqk8j8uia">
                    {active.map(s => <option key={s.id} value={s.id} data-id="element-5319" data-mp="oetld6exu6ik">
                        {s.name}
                      </option>)}
                    {/* Een gestopte collega die nog op deze dag staat: zichtbaar, zodat Sarah het ziet en wijzigt. */}
                    {d.staffId && !active.some(s => s.id === d.staffId) && <option value={d.staffId} data-id="element-5320" data-mp="2v9guawaso2yg">{staffName(staff, d.staffId)} (gestopt)</option>}
                  </select>}
                {wrong && <span id={errorId} role="alert" className="col-span-3 text-[12px] text-clay" data-id="element-5321" data-mp="23wy7vwile3oz">
                    Sluit vóór opening
                  </span>}
              </span> : <span className="hidden text-[13px] text-muted sm:inline" data-id="element-5322" data-mp="2dvxgxg79s1ci">Gesloten</span>}
          </li>;
    })}
    </ul>;
}